import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";
import ImageGallery from 'react-image-gallery';
import "./../image-gallery.css";

export default () => {
    const title = 'Озеро Мульное';

    const images = [
        {
            original: require('./../img/virtualtours/mulnoieozero/mul000.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul000.jpg'),
            description: 'Озеро Мульное',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul001.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul001.jpg'),
            description: 'Чистая вода',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul002.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul002.jpg'),
            description: 'Прозрачность',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul003.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul003.jpg'),
            description: 'Озеро Мульное',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul004.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul004.jpg'),
            description: 'Берег',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul005.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul005.jpg'),
            description: 'Озеро Мульное',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul006.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul006.jpg'),
            description: 'Стоянка',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul007.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul007.jpg'),
            description: 'Лагерь',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul008.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul008.jpg'),
            description: 'Озеро Мульное',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul009.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul009.jpg'),
            description: 'Лягушатник',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul010.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul010.jpg'),
            description: 'Костер',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul011.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul011.jpg'),
            description: 'Камни',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul012.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul012.jpg'),
            description: 'Волейбол',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul013.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul013.jpg'),
            description: 'Озеро Мульное',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul014.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul014.jpg'),
            description: 'Волны',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul015.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul015.jpg'),
            description: 'Поляна',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul016.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul016.jpg'),
            description: 'Зона отдыха',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul017.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul017.jpg'),
            description: 'Туристы',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul018.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul018.jpg'),
            description: 'Лодка',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul019.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul019.jpg'),
            description: 'Озеро Мульное',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul020.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul020.jpg'),
            description: 'На лодке',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul021.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul021.jpg'),
            description: 'Озеро Мульное',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul022.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul022.jpg'),
            description: 'Озеро Мульное',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul023.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul023.jpg'),
            description: 'Озеро Мульное',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul024.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul024.jpg'),
            description: 'Озеро Мульное',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul025.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul025.jpg'),
            description: 'Рыбы',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul026.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul026.jpg'),
            description: 'Рыбы',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul027.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul027.jpg'),
            description: 'Уха',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul028.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul028.jpg'),
            description: 'Озеро Мульное',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul029.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul029.jpg'),
            description: 'Озеро Мульное',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul030.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul030.jpg'),
            description: 'Березки',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul031.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul031.jpg'),
            description: 'Стрекоза',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul032.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul032.jpg'),
            description: 'Камыши',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul033.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul033.jpg'),
            description: 'Камыши',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul034.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul034.jpg'),
            description: 'Бабочка',
        },
        {
            original: require('./../img/virtualtours/mulnoieozero/mul035.jpg'),
            thumbnail: require('./../img/virtualtours/mulnoieozero/mmul035.jpg'),
            description: 'Причал',
        },
    ];

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <div className="onehalf-col-cell">
                        <h2>{title}</h2>
                        <ImageGallery
                            items={images}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                </div>

                <div className="pageitem">
                    <p>МУЛЬНОЕ, озеро в Ивановском районе, в бассейне Ясельды, к юго-западу от деревни Тышковичи
                        (Мотольское хозяйство).</p>
                    <p>Склоны котловины низкие, распаханы, на западе и востоке закустарены, на севере терраса высотой
                        до 2 м. Литораль шириной от 10 до 150 м, песчаная. Остальная часть дна озера выстлана
                        сапропелем. Зарастает до глубины 3 м. На берегах (на востоке и юго-востоке) археологические
                        памятники - стоянки древнего человека.</p>
                    <ul>
                        <li>площадь: 0,51 км2</li>
                        <li>длина: 0,9 км</li>
                        <li>максимальная ширина: 0,8 км</li>
                        <li>максимальная глубина: 21 м</li>
                        <li>средняя глубина: 4,8 м.</li>
                    </ul>
                </div>
            </div>
        </>
    );
}